import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { isV2Dealership } from 'app/utils/dealerVersion';
import { hasDealerContext } from 'utils/hasDealerContext';

export const useV2DealerRequiredRedirect = () => {
  const selectedDealer = useSelector(selectDealerSelected);
  const hasDealer = hasDealerContext(selectedDealer);
  const isV2 = isV2Dealership(selectedDealer);
  const isBlocked = hasDealer && !isV2;

  return { hasDealer, isV2Dealership: isV2, isBlocked };
};
